import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { ToastableItem } from '@radioking/shared/common-services';

import {
  CreateProgramFailure,
  CreateProgramSuccess,
  DeleteProgramFailure,
  DeleteProgramSuccess,
  DuplicateProgramFailure,
  DuplicateProgramSuccess,
  EditProgramFailure,
  EditProgramSuccess,
  PreviewProgramFailure,
  ProgramAddPlaylistFailure,
  ProgramAddPlaylistSuccess,
  ProgramDeletePlaylistFailure,
  ProgramDeletePlaylistSuccess,
  ProgramDuplicatePlaylistFailure,
  ProgramDuplicatePlaylistSuccess,
  ProgramEditPlaylistFailure,
  ProgramEditPlaylistSuccess,
  ProgramMovePlaylistFailure,
  ProgramMovePlaylistSuccess,
  ProgramPlaylistsFailure,
} from './states/programs.actions';

export const programsToasts: ToastableItem[] = [
  {
    action: CreateProgramSuccess,
    level: 'success',
    translationKey: marker('TOAST.PROGRAMS.CREATE_SUCCESS'),
  },
  {
    action: DuplicateProgramSuccess,
    level: 'success',
    translationKey: marker('TOAST.PROGRAMS.CREATE_SUCCESS'),
  },
  {
    action: EditProgramSuccess,
    level: 'success',
    translationKey: marker('TOAST.PROGRAMS.EDIT_SUCCESS'),
  },
  {
    action: DeleteProgramSuccess,
    level: 'success',
    translationKey: marker('TOAST.PROGRAMS.DELETE_SUCCESS'),
  },
  {
    action: ProgramAddPlaylistSuccess,
    level: 'success',
    translationKey: marker('TOAST.PROGRAMS.ADD_PLAYLIST_SUCCESS'),
  },
  {
    action: ProgramEditPlaylistSuccess,
    level: 'success',
    translationKey: marker('TOAST.PROGRAMS.EDIT_PLAYLIST_SUCCESS'),
  },
  {
    action: ProgramDeletePlaylistSuccess,
    level: 'success',
    translationKey: marker('TOAST.PROGRAMS.DELETE_PLAYLIST_SUCCESS'),
  },
  {
    action: CreateProgramFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.CREATE_ERROR'),
  },
  {
    action: DuplicateProgramFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.CREATE_ERROR'),
  },
  {
    action: EditProgramFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.EDIT_ERROR'),
  },
  {
    action: DeleteProgramFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.DELETE_ERROR'),
  },
  {
    action: ProgramAddPlaylistFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.ADD_PLAYLIST_ERROR'),
  },
  {
    action: ProgramDeletePlaylistFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.DELETE_PLAYLIST_ERROR'),
  },
  {
    action: ProgramPlaylistsFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.GET_PLAYLISTS_ERROR'),
  },
  {
    action: ProgramEditPlaylistFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.EDIT_PLAYLIST_ERROR'),
  },
  {
    action: ProgramMovePlaylistSuccess,
    level: 'success',
    translationKey: marker('TOAST.PROGRAMS.MOVE_PLAYLIST_SUCCESS'),
  },
  {
    action: ProgramMovePlaylistFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.MOVE_PLAYLIST_ERROR'),
  },
  {
    action: ProgramDuplicatePlaylistSuccess,
    level: 'success',
    translationKey: marker('TOAST.PROGRAMS.ADD_PLAYLIST_SUCCESS'),
  },
  {
    action: ProgramDuplicatePlaylistFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.ADD_PLAYLIST_ERROR'),
  },
  {
    action: PreviewProgramFailure,
    level: 'error',
    translationKey: marker('TOAST.PROGRAMS.PREVIEW_PROGRAM_ERROR'),
  },
];
